module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-hedo-01@2x.42f6de70.png";